var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tw-flex tw-items-center tw-gap-5 tw-rounded"},[_c('input',{attrs:{"id":_vm.id,"name":_vm.name,"type":"checkbox"}}),_c('label',{staticClass:"tw-text-sm",attrs:{"for":_vm.name}},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }